<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit(item)">
    <v-text-field
      v-model="item.firstName"
      type="text"
      label="First Name"
      hint="The user first name"
      required
      :rules="firstNameRules"
      :error-messages="isInvalid('firstName') ? violations.firstName : []"
    ></v-text-field>
    <v-text-field
      v-model="item.lastName"
      type="text"
      label="Last Name"
      hint="The user last name"
      required
      :rules="lastNameRules"
      :error-messages="isInvalid('lastName') ? violations.lastName : []"
    ></v-text-field>
    <v-text-field
      v-model="item.username"
      type="text"
      label="Username"
      hint="The user username"
      required
      :rules="usernameRules"
      :error-messages="isInvalid('username') ? violations.username : []"
    ></v-text-field>
    <v-text-field
      v-model="item.email"
      type="text"
      label="Email"
      hint="The user email"
      required
      :rules="emailRules"
      :error-messages="isInvalid('email') ? violations.email : []"
    ></v-text-field>
    <v-select
      v-model="item.locale"
      :items="locales"
      required
      :rules="localeRules"
      item-value="value"
      item-text="text"
      :label="$t('message.language')"
      :hint="$t('message.user_language')"
    ></v-select>
  </v-form>
</template>

<script>
export default {
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      item: JSON.parse(JSON.stringify(this.values)),
      valid: true,
      locales: [
        {
          text: this.$t('message.english'),
          value: 'en'
        },
        {
          text: this.$t('message.spanish'),
          value: 'es'
        }
      ],
      usernameRules: [
        v => {
          return !!v || 'Username is required'
        }
      ],
      firstNameRules: [
        v => {
          return !!v || 'First name is required'
        }
      ],
      lastNameRules: [
        v => {
          return !!v || 'Last name is required'
        }
      ],
      localeRules: [
        v => {
          return !!v || 'Language is required'
        }
      ],
      emailRules: [
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      ]
    }
  },

  computed: {
    violations() {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid(key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
